(function () {
  'use strict';

  let dialog = null;
  let lastTrigger = null;

  function build() {
    if (dialog) return dialog;
    dialog = document.createElement('div');
    dialog.className = 'a-qv';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.hidden = true;
    dialog.innerHTML =
      '<div class="a-qv__scrim" data-qv-close></div>' +
      '<div class="a-qv__panel">' +
        '<button type="button" class="a-qv__close" data-qv-close aria-label="Close">&times;</button>' +
        '<p class="a-qv__eyebrow" data-qv-eyebrow></p>' +
        '<h2 class="a-h3 a-qv__title" data-qv-title></h2>' +
        '<span class="a-rule a-qv__rule"></span>' +
        '<ul class="a-qv__grid" data-qv-grid role="list"></ul>' +
        '<a class="a-btn a-btn--primary a-btn--full a-qv__cta" data-qv-cta>View full product</a>' +
      '</div>';
    document.body.appendChild(dialog);

    dialog.addEventListener('click', (e) => {
      if (e.target.closest('[data-qv-close]')) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !dialog.hidden) close();
    });
    return dialog;
  }

  function open(data, trigger) {
    const d = build();
    lastTrigger = trigger;

    d.querySelector('[data-qv-eyebrow]').textContent =
      (data.optionName || 'Style') + ' options';
    d.querySelector('[data-qv-title]').textContent = data.title || '';

    const grid = d.querySelector('[data-qv-grid]');
    grid.innerHTML = '';

    (data.values || []).forEach((v) => {
      const li = document.createElement('li');
      li.className = 'a-qv__item' + (v.available ? '' : ' is-out');

      const a = document.createElement('a');
      a.className = 'a-qv__link';
      a.href = data.url || '#';

      if (v.image) {
        const fig = document.createElement('span');
        fig.className = 'a-qv__media a-tile';
        const img = document.createElement('img');
        img.src = v.image;
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        fig.appendChild(img);
        a.appendChild(fig);
      }

      const name = document.createElement('span');
      name.className = 'a-qv__name';
      name.textContent = v.name;
      a.appendChild(name);

      if (v.price) {
        const price = document.createElement('span');
        price.className = 'a-qv__price';
        price.textContent = v.price;
        a.appendChild(price);
      }

      if (!v.available) {
        const tag = document.createElement('span');
        tag.className = 'a-qv__tag';
        tag.textContent = 'Made to order';
        a.appendChild(tag);
      }

      li.appendChild(a);
      grid.appendChild(li);
    });

    d.querySelector('[data-qv-cta]').href = data.url || '#';
    d.hidden = false;
    document.body.classList.add('a-qv-open');
    requestAnimationFrame(() => d.classList.add('is-open'));
    d.querySelector('.a-qv__close').focus();
  }

  function close() {
    if (!dialog) return;
    dialog.classList.remove('is-open');
    document.body.classList.remove('a-qv-open');
    setTimeout(() => { dialog.hidden = true; }, 200);
    if (lastTrigger) lastTrigger.focus();
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-athena-quickview]');
    if (!btn) return;
    e.preventDefault();
    const holder = btn.parentElement.querySelector('[data-athena-styles]');
    if (!holder) return;
    try {
      open(JSON.parse(holder.textContent), btn);
    } catch (err) {
      window.location.href = btn.closest('.a-card').querySelector('.a-card__link').href;
    }
  });
})();
